<template>
  <div class="qualityServiceProviderMesg">
    <div class="flex qualityService_box" v-for="(item, index) in sellerList" :key="index">
      <div class="qualityService_box_left">
        <img :src="item.logo?item.logo:require('../../../../assets/image/fuwu.jpg')" alt="" />
        <p v-if="item.followUuid && showPhone" @click="removeFollow(item.followUuid)">取消关注</p>
        <p v-else @click="collectSeller(item.enterpriseUuid)">关注</p>
      </div>
      <div class="qualityService_box_rihgt">
        <h2 style="cursor: pointer" @click="getQualityServiceProviderDetails(item.enterpriseUuid)">{{ item.name }}</h2>
        <div class="flex-item-center" v-if="item.oneLable">
          <span class="tags" v-for="(itemOne, indexOne) in item.oneLableList" :key="indexOne">{{ itemOne }}</span>
        </div>
        <div class="qualityService_box_rihgt_megs">
          <div class="rihgt_megs">
            <p>联系人： {{ item.contact }}</p>
            <p class="rihgt_megs2_center">成交笔数： {{ item.orderNum }} 笔</p>
            <p class="rihgt_megs2_right">
              服务数: <span class="grColor geSize">{{ item.serviceNum }}</span>条
            </p>
          </div>
          <div class="rihgt_megs2">
            <p>
              电&nbsp;&nbsp;&nbsp;话：<span class="grColor">{{ item.contactTel }}</span><!-- <span v-if="showPhone" class="grColor">{{ item.contactTel }}</span><span v-else class="grColor">登录查看</span>-->
            </p>
            <p class="rihgt_megs2_center">综合好评： {{ item.evaluationNumber }}%</p>
          </div>
          <div class="rihgt_megs2">
            <p>地&nbsp;&nbsp;&nbsp;址： {{ item.province }}{{ item.city }}{{ item.district }}</p>
            <p class="rihgt_megs2_center">&nbsp;&nbsp;&nbsp;关注量： {{ item.fsCount }}</p>
          </div>
        </div>
        <div class="btn">
          <i></i>
          <p @click="getQualityServiceProviderDetails(item.enterpriseUuid)">查看详情</p>
        </div>
      </div>
    </div>
    <div style="text-align: right; width: 100%; margin-top: 30px">
      <el-pagination
        style="margin-right: -10px"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getEvaluationNumberByEnterpriseUuid,
  getSellerProvidersList,
  removeCollection,
  removeFollow,
  saveFollow,
  saveServiceCollection
} from "../../../../utils/interface";
import {mapState} from "vuex";

export default {
  data() {
    return {
      current: 1,
      pageSize: 10,
      total: 0,
      name:'',
      classifyOne:'',
      classifyTwo:'',
      sellerList:[],
      showPhone:false,
      userUuid:this.$store.state.isUsermessage.uuid
    };
  },
  methods: {
    init(param){
      if (this.$store.state.isLogin){
        this.showPhone=true;
      }
      if(this.$store.state.isLogin){
        this.isLogin=true;
      }
      this.name = param.name;
      this.classifyOne = param.classifyOne;
      this.classifyTwo = param.classifyTwo;
      this.providerList(param);
    },
    providerList(mesg){
      let param={
        name:mesg.name,
        oneClass:mesg.classifyOne,
        twoClass:mesg.classifyTwo,
        current: this.current,
        pageSize: this.pageSize,
        userUuid:this.userUuid
      };
      getSellerProvidersList(param).then((res)=>{
        this.sellerList = res.list;
        this.total = res.total;
        this.pageSize = res.size;
        this.current = res.current;
        this.$emit('onTotal', res.total)
        this.sellerList.map((item, index) => {
          item.oneLableList = item.oneLable.split(",");
          getEvaluationNumberByEnterpriseUuid({
            enterpriseUuid: item.enterpriseUuid
          }).then((resq) => {
            if (resq.success) {
              this.$set(this.sellerList[index], "evaluationNumber", resq.data.evaluationNumber);
              this.$set(this.sellerList[index], "goodsNum", resq.data.goodsNum);
            }
          });
        })
      })
    },
    handleCurrentChange(val) {
      // this.current = val;
      // window.scrollTo(0,0);
      // this.getShopList();
      this.current = val;
      this.$emit("changeList")
      // this.providerList();
    },
    getQualityServiceProviderDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    collectSeller(enterpriseUuid){
      console.log("-----this.$store.state.isLogin--------"+this.$store.state.isLogin)
      if (this.$store.state.isLogin) {
        console.log("-----this.enterpriseUuid--------"+enterpriseUuid)
        console.log("-----this.isUsermessage--------",this.$store.state.isUsermessage)
        if (this.$store.state.isUsermessage.enterpriseUuid == enterpriseUuid) {
          this.$message.error('无法关注自己');
          return false;
        }
        let params = {
          enterPriseUuid: enterpriseUuid,
          followType: 'SELLER'
        };
        saveFollow(params).then((res) => {
          if (res.success) {
            this.$message.success('关注成功!');
            this.$emit("changeList")
          }
        });
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    removeFollow(followUuid){
      // 收藏服务
      let params = {
        uuid:followUuid,
      };
      removeFollow(params).then((res)=>{
        if(res.success){
          this.$message.success('取消成功!');
          this.$emit("changeList")
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/index.less";
.grColor {
  color: #099;
}
.geSize {
  font-size: 20px;
}
.qualityServiceProviderMesg {
  margin-top: 20px;
  .qualityService_box {
  padding: 30px;
  background: #fff;
    margin-bottom: 2px;
  }
  .qualityService_box_left {
    margin-right: 20px;
    text-align: center;
    img {
      width: 190px;
      height: 90px;
      margin-bottom: 42px;
      flex-shrink: 0;
      border-radius: 10px;
      box-shadow: 0 5px 5px #efefef;
    }
    p {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #099;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .qualityService_box_rihgt {
    width: 100%;
    line-height: 30px;
    position: relative;
    h2 {
      font-size: 20px;
      margin-bottom: 11px;
    }
    .tags {
      min-width: 64px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      background: #eaf3ff;
      border-radius: 4px;
      border: 1px solid #cbe1ff;
      font-size: 12px;
      color: #2a5bc9;
      margin-right: 8px;
    }
    .qualityService_box_rihgt_megs {
      margin-top: 20px;
      font-size: 14px;
      span {
        margin-right: 5px;
      }
    }
    .rihgt_megs {
      display: grid;
      grid-template-columns: 33% 33% 33%;
    }
    .rihgt_megs2 {
      display: grid;
      grid-template-columns: 33% 33%;
    }
    .rihgt_megs2_center {
      text-align: center;
    }
    .rihgt_megs2_right {
      text-align: right;
    }
    .btn {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #009999;
      font-size: 14px;
      font-weight: 500;
      color: #009999;
      position: absolute;
      right: 8px;
      bottom: 5px;
      cursor: pointer;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/list/qualityServiceProviderMesg.vue